// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import ProtectedRoute from 'components/auth/ProtectedRoute';
import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes.js';
import { getDashboardRoute, getRoutesForRole } from 'utils/routeHelpers';

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  
  // Filter routes based on user role
  const filteredRoutes = getRoutesForRole(routes);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes) => {
    let activeRoute = 'Dashboard';
    const routesToCheck = routes || filteredRoutes;
    const currentPath = window.location.pathname;
    
    for (let i = 0; i < routesToCheck.length; i++) {
      if (routesToCheck[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routesToCheck[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routesToCheck[i].category) {
        let categoryActiveRoute = getActiveRoute(routesToCheck[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        const routePath = routesToCheck[i].layout + routesToCheck[i].path;
        // Handle dynamic routes (with :id, :slug, etc.)
        if (routePath.includes(':')) {
          const routePattern = routePath.replace(/:[^/]+/g, '[^/]+');
          const regex = new RegExp('^' + routePattern.replace(/\//g, '\\/') + '$');
          if (regex.test(currentPath)) {
            return routesToCheck[i].name;
          }
        } else if (currentPath === routePath || currentPath.startsWith(routePath + '/')) {
          return routesToCheck[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    const routesToCheck = routes || filteredRoutes;
    for (let i = 0; i < routesToCheck.length; i++) {
      if (routesToCheck[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routesToCheck[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routesToCheck[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routesToCheck[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routesToCheck[i].layout + routesToCheck[i].path) !== -1
        ) {
          return routesToCheck[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    const routesToCheck = routes || filteredRoutes;
    for (let i = 0; i < routesToCheck.length; i++) {
      if (routesToCheck[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routesToCheck[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routesToCheck[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routesToCheck[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routesToCheck[i].layout + routesToCheck[i].path) !== -1
        ) {
          return routesToCheck[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routesToMap) => {
    const routesToCheck = routesToMap || filteredRoutes;
    return routesToCheck.map((route, key) => {
      if (route.layout === '/admin') {
        return (
          <Route
            path={`${route.path}`}
            element={
              <ProtectedRoute
                allowedRoles={route.allowedRoles}
                requireAuth={true}
              >
                {route.component}
              </ProtectedRoute>
            }
            key={key}
          />
        );
      }
      if (route.collapse || route.category) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={filteredRoutes} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Afriq-NW Dashboard'}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {getRoutes(filteredRoutes)}
                  <Route
                    path="/"
                    element={<Navigate to={getDashboardRoute()} replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
